/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';

import { RentReportData } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';
import { DateConverter } from 'src/sections/common/DateConverter';

type Props = {
  Report?: RentReportData;
  fromYear?: number;
  fromMonth?: number;
  toYear?: number;
  toMonth?: number;
  paymentDate?: Date;
  checkedData?: boolean;
};

export default function RentPaymentReportPDF({ Report, checkedData, fromYear, fromMonth, toYear, toMonth, paymentDate }: Props) {
  const recordsPerPage = 25;
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');

  const lang = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirction]);


  if (!Report || !Report.list || Report.list.length === 0) {
    return <Loader />;
  }

  const thStyle = `table-th-Attandence-Report text-[12px]`;

  const tdStyle = `table-td-Attandence-Report text-[11px]`;

  const width = 'w-[240mm]';

  const totalPages = Math.ceil(Report!.list.length / recordsPerPage);

  const flatReport = Report.report.flat();

  // const groupedData = flatReport.reduce((acc, item) => {
  //   // Group by Year
  //   if (!acc[item.year]) {
  //     acc[item.year] = {};
  //   }

  //   // Group by Month within Year
  //   if (!acc[item.year][item.month]) {
  //     acc[item.year][item.month] = [];
  //   }

  //   // Add Currency Data
  //   acc[item.year][item.month].push({
  //     currencyId: item.currencyId,
  //     currencyName: item.currencyName,
  //     totalPaymentAmount: item.totalPaymentAmount,
  //     totalPaidAmount: item.totalPaidAmount,
  //     totalRemainAmount: item.totalRemainAmount,
  //   });

  //   return acc;
  // }, {} as Record<number, Record<number, any[]>>);


  // Calculate grand total
  // const totalsByCurrency = flatReport.reduce((acc, item) => {
  //   const key = item.currencyId;
  //   if (!acc[key]) {
  //     acc[key] = {
  //       currencyId: item.currencyId,
  //       currencyName: item.currencyName,
  //       totalPaymentAmount: 0,
  //       totalPaidAmount: 0,
  //       totalRemainAmount: 0,
  //     };
  //   }
  //   acc[key].totalPaymentAmount += item.totalPaymentAmount || 0;
  //   acc[key].totalPaidAmount += item.totalPaidAmount || 0;
  //   acc[key].totalRemainAmount += item.totalRemainAmount || 0;
  //   return acc;
  // }, {} as Record<number, {
  //   currencyId: number;
  //   currencyName: string;
  //   totalPaymentAmount: number;
  //   totalPaidAmount: number;
  //   totalRemainAmount: number;
  // }>);

  return (
    <>
      <div className="px-7">
        {Report.list.length > 0 ? (
          <>
            {/* Loop through pages */}
            {Array.from({ length: totalPages }).map((_, pageIndex) => (
              <div
                key={pageIndex}
                className={`${width} h-[297mm] mx-auto bg-white text-black`}
                dir={`${dirction}`}
              >
                <div className="page-break py-5 px-2">
                  <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                    <div className="flex justify-between items-center px-5">
                      {/* Left Logo */}
                      <div className="flex flex-col justify-center items-center text-center">
                        <img
                          src={require('src/assets/Choqorak/logo1.png')}
                          width="100"
                          height="100"
                          alt="logo1"
                        />
                      </div>

                      {/* Center Text */}
                      <div className="text-base text-center font-bold print:text-base">
                        <h3>چقرک مرکز پخش مواد خوراکی</h3>
                        <h3>گزارش دریافتی‌های کرایه</h3>
                        {checkedData ? (
                          <h3>
                            گزارش {new Date(paymentDate ?? new Date()).toLocaleDateString('fa-IR')}
                          </h3>
                        ) : (
                          fromYear === toYear && fromMonth === toMonth ? (
                            <h3>گزارش سال {fromYear} ماه {GetMonthName(fromMonth, 'dr')}  </h3>
                          ) : (
                            <h3>گزارش سال {fromYear} ماه {GetMonthName(fromMonth, 'dr')} الی سال {toYear} ماه {GetMonthName(toMonth, 'dr')} </h3>
                          )
                        )}
                      </div>

                      {/* Right Logo */}
                      <div className="flex flex-col justify-center items-center text-center">
                        <img
                          src={require('src/assets/Choqorak/logo2.png')}
                          width="200"
                          height="400"
                          alt="logo2"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <table className="table-style print:text-black">
                      <thead className=" bg-gray-600">
                        <tr className="w-full bg-gray-600 print:bg-gray-600">
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.No')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.Year')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.Month')}
                          </th>
                          {/* <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.ContractNumber')}
                          </th> */}
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.CustomerName')}
                          </th>
                          {/* <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.CustomerPhone')}
                          </th> */}
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.ShopCode')}
                          </th>
                          {/* <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('GeneralFields.StartDate')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('GeneralFields.EndDate')}
                          </th> */}
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPayment.RecievedByUserName')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPayment.CurrentMonthRent')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPayment.RemainFromThePast')}
                          </th>


                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.PaymentAmount')}
                          </th>
                          {checkedData ? (
                            <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                              {translate('RentPayment.TodaysRecievedAmount')}
                            </th>
                          ) : ''}
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.PaidAmount')}
                          </th>

                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.RemainAmount')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPayment.PaymentDate')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Report!.list
                          .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                          .map((record: any, index: number) => (
                            <tr key={index} style={{ pageBreakInside: 'avoid' }}>
                              <td className={`${tdStyle}`}>{pageIndex * recordsPerPage + index + 1}</td>
                              <td className={`${tdStyle}`}>{record.year}</td>
                              <td className={`${tdStyle}`}>{GetMonthName(record.month)}</td>
                              {/* <td className={`${tdStyle}`}>{record.contractNumber}</td> */}
                              <td className={`${tdStyle}`}>{record.customerName}</td>
                              {/* <td className={`${tdStyle}`}>{record.customerPhone}</td> */}
                              <td className={`${tdStyle}`}>{record.shopCode}</td>
                              {/* <td className={`${tdStyle}`}>{record.ContractStartDate}</td>
                              <td className={`${tdStyle}`}>{record.ContractEndDate}</td> */}
                              <td className={`${tdStyle}`}>{record.recievedByUserName}</td>

                              <td className={`${tdStyle}`}>
                                {record.currentMonthRent}{' '}
                                {record.currencyId === 2
                                  ? GetCurrencySymbol('afn')
                                  : GetCurrencySymbol('dollar')}
                              </td>
                              <td className={`${tdStyle}`}>
                                {record.remnantsOfThePast}{' '}
                                {record.currencyId === 2
                                  ? GetCurrencySymbol('afn')
                                  : GetCurrencySymbol('dollar')}
                              </td>
                              <td className={`${tdStyle}`}>
                                {record.paymentAmount}{' '}
                                {record.currencyId === 2
                                  ? GetCurrencySymbol('afn')
                                  : GetCurrencySymbol('dollar')}
                              </td>
                              {checkedData ? (
                                <td className={`${tdStyle}`}>
                                  {record.todaysRecievedAmount}{' '}
                                  {record.currencyId === 2
                                    ? GetCurrencySymbol('afn')
                                    : GetCurrencySymbol('dollar')}
                                </td>
                              ) : ''}
                              <td className={`${tdStyle}`}>
                                {record.paidAmount}{' '}
                                {record.currencyId === 2
                                  ? GetCurrencySymbol('afn')
                                  : GetCurrencySymbol('dollar')}
                              </td>

                              <td className={`${tdStyle}`}>
                                {record.remainAmount}{' '}
                                {record.currencyId === 2
                                  ? GetCurrencySymbol('afn')
                                  : GetCurrencySymbol('dollar')}
                              </td>
                              <td className={`${tdStyle}`}>
                                {<DateConverter date={record?.paymentDate} />}{' '}

                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Footer for each page */}
                  {/* <div
              className={`absolute bottom-5 w-[230mm] mx-auto border-t-2 border-black text-[8pt]`}
            >
              <div className="px-5 relative w-full mx-auto" dir="ltr">
                <div className="flex justify-center items-center w-full">
                  <img
                    src={require('src/assets/Choqorak/footer.png')}
                    width="500"
                    height="50"
                    alt="footer"
                  />
                </div>
              </div>
            </div> */}
                </div>

                {/* Show Summary ONLY on the Last Page */}
                {pageIndex === totalPages - 1 && (
                  <div
                    className={`${width} h-[297mm] mx-auto bg-white text-black`}
                    dir={`${dirction}`}
                  >
                    <div className="page-break py-5 px-2">
                      <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                        <div className="flex justify-between items-center px-5">
                          {/* Left Logo */}
                          <div className="flex flex-col justify-center items-center text-center">
                            <img
                              src={require('src/assets/Choqorak/logo1.png')}
                              width="100"
                              height="100"
                              alt="logo1"
                            />
                          </div>

                          {/* Center Text */}
                          <div className="text-base text-center font-bold print:text-base">
                            <h3>چقرک مرکز پخش مواد خوراکی</h3>
                            <h3>گزارش دریافتی‌های کرایه</h3>
                            {checkedData ? (
                              <h3>
                                گزارش {new Date(paymentDate ?? new Date()).toLocaleDateString('fa-IR')}
                              </h3>
                            ) : (
                              fromYear === toYear && fromMonth === toMonth ? (
                                <h3>گزارش سال {fromYear} ماه {GetMonthName(fromMonth, 'dr')}  </h3>
                              ) : (
                                <h3>گزارش سال {fromYear} ماه {GetMonthName(fromMonth, 'dr')} الی سال {toYear} ماه {GetMonthName(toMonth, 'dr')} </h3>
                              )
                            )}
                          </div>

                          {/* Right Logo */}
                          <div className="flex flex-col justify-center items-center text-center">
                            <img
                              src={require('src/assets/Choqorak/logo2.png')}
                              width="200"
                              height="400"
                              alt="logo2"
                            />
                          </div>
                        </div>
                      </div>
                      {/* Summary Section */}
                      <div>
                        <h3 className="text-center text-xl font-bold border-4 border-black p-2">
                          {translate('Shop.Report.ReportSummary')}
                        </h3>
                        <table className="w-full border border-black text-left text-sm">
                          <thead>
                            <tr className="bg-gray-200">
                              {/* <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('ElectricityPrint.Year')}
                              </th>
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('ElectricityPrint.Month')}
                              </th> */}
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('Income.Currency')}
                              </th>

                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('ReportSummary.TotalPaymentAmount')}
                              </th>
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('ReportSummary.TotalPaidAmount')}
                              </th>
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('ReportSummary.TotalRemainAmount')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* {Object.entries(groupedData).map(([year, months]) => {
                              const yearRowSpan = Object.values(months).reduce(
                                (sum, currencies) => sum + currencies.length,
                                0
                              );

                              return Object.entries(months).map(([month, currencies], monthIndex) =>
                                currencies.map((currency, currencyIndex) => (
                                  <tr key={`${year}-${month}-${currency.currencyName}`}>
                                    {monthIndex === 0 && currencyIndex === 0 && (
                                      <td
                                        className="px-4 py-2 border border-black text-center"
                                        rowSpan={yearRowSpan}
                                      >
                                        {year}
                                      </td>
                                    )}

                                    {currencyIndex === 0 && (
                                      <td
                                        className="px-4 py-2 border border-black text-center"
                                        rowSpan={currencies.length}
                                      >
                                        {GetMonthName(parseInt(month))}
                                      </td>
                                    )}

                                    <td className="px-4 py-2 border border-black text-center">
                                      {currency.currencyName}
                                    </td>

                                    <td className="px-4 py-2 border border-black text-center">
                                      {currency.totalPaymentAmount}{' '}
                                      {currency.currencyId === 2
                                        ? GetCurrencySymbol('afn')
                                        : GetCurrencySymbol('dollar')}
                                    </td>
                                    <td className="px-4 py-2 border border-black text-center">
                                      {currency.totalPaidAmount}{' '}
                                      {currency.currencyId === 2
                                        ? GetCurrencySymbol('afn')
                                        : GetCurrencySymbol('dollar')}
                                    </td>
                                    <td className="px-4 py-2 border border-black text-center">
                                      {currency.totalRemainAmount}{' '}
                                      {currency.currencyId === 2
                                        ? GetCurrencySymbol('afn')
                                        : GetCurrencySymbol('dollar')}
                                    </td>
                                  </tr>
                                ))
                              );
                            })} */}

                            {/* ردیف مجموع عمومی */}
                            {flatReport.map((total) => (
                              <tr key={`${total.year}-${total.month}-${total.currencyId}`} className="bg-gray-200 font-bold">
                                <td  className="px-4 py-2 border border-black text-center">
                                ({total.currencyName})
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {total.totalPaymentAmount}{' '}
                                  {total.currencyId === 2
                                    ? GetCurrencySymbol('afn')
                                    : GetCurrencySymbol('dollar')}
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {total.totalPaidAmount}{' '}
                                  {total.currencyId === 2
                                    ? GetCurrencySymbol('afn')
                                    : GetCurrencySymbol('dollar')}
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {total.totalRemainAmount}{' '}
                                  {total.currencyId === 2
                                    ? GetCurrencySymbol('afn')
                                    : GetCurrencySymbol('dollar')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Footer Section */}
                      {/* <div
                        className={`print:fixed print:bottom-5 print:w-[230mm] print:mx-auto print:border-t-2 print:border-black text-[8pt] hidden print:block`}
                      >
                        <div className="px-5 relative w-full mx-auto" dir="ltr">
                          <div className="flex justify-center items-center w-full">
                            <img
                              src={require('src/assets/Choqorak/footer.png')}
                              width="500"
                              height="50"
                              alt="footer"
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <div className="flex justify-center items-center">
            {translate('ReceptionDashboard.NoRecordFound')}
          </div>
        )}
      </div>
    </>
  );
}
